<template>
  <div class="slim-mainpanel">
    <desk-state-modal
      v-if="modal.deskState.show"
      @close="closeModalDeskState"
      @finish="closeModalDeskState"
      :statusFilters="reportDeskSteps"
      :filter="filter"
      :columns="tableColumns"
      context="REPORT_IMP_GENERAL"
    />
    <div class="container">
      <div class="slim-pageheader">
        <ol class="breadcrumb slim-breadcrumb">
          <li class="breadcrumb-item"><a href="#">Operacional</a></li>
          <li class="breadcrumb-item"><a href="#">Importação</a></li>
          <li class="breadcrumb-item"><a href="#">Relatórios</a></li>
          <li class="breadcrumb-item active" aria-current="page">
            Relatório Geral de Importações
          </li>
        </ol>
        <h6 class="slim-pagetitle">Relatório Geral de Importações</h6>
      </div>

      <div class="bd bd-1 bd-b-0">
        <div
          class="bd-t bd-5 bd-gray-800 pd-x-10 bg-white d-flex justify-content-between align-items-center pd-b-5 pd-t-5"
        >
          <ul class="nav">
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo">
                <a href="#" class="dd-link" data-toggle="dropdown">
                  <div
                    v-if="
                      filter.date.start !== '' &&
                      filter.date.end !== '' &&
                      filter.date.field !== ''
                    "
                  >
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-calendar tx-info"></i> Período:
                      <span
                        class="pd-x-5 badge badge-info mg-b-0 mg-r-2-force tx-thin-force"
                      >
                        {{ filter.date.field.label }} de
                        {{ filter.date.start | moment("DD/MM/YYYY") }} até
                        {{ filter.date.end | moment("DD/MM/YYYY") }}
                      </span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span> <i class="fa fa-calendar mg-r-5"></i> Período</span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Data do Período dos Processos
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um campo e uma data inicial e final
                  </p>

                  <div class="form-layout form-layout-2 modify">
                    <div class="row no-gutters">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="form-control-label">
                            Data Inicial <span class="tx-danger">*</span></label
                          >
                          <date-picker lang="pt-br"
                                       v-model="filter.date.start"
                                       name="toPickedDate"
                                       format="DD/MM/YYYY"
                                       placeholder="Data Inicial"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="col-md-6 mg-t--1 mg-md-t-0">
                        <div class="form-group mg-md-l--1">
                          <label class="form-control-label">
                            Data Final <span class="tx-danger">*</span></label
                          >
                          <date-picker lang="pt-br"
                                       v-model="filter.date.end"
                                       name="toPickedDate"
                                       format="DD/MM/YYYY"
                                       placeholder="Data Final"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group bd-t-0-force">
                          <label class="form-control-label">
                            Campo do Filtro
                          </label>
                          <v-select
                            v-model="filter.date.field"
                            :options="listOfDatesFields"
                            name="label"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.label }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.customers.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-building tx-danger mg-r-5"></i>Clientes:
                      <span
                        class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="c in filter.customers"
                        :key="c.id"
                      >
                        {{ c.name }}</span
                      >
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span
                    ><i class="fa fa-building tx-medium mg-r-5"></i> Clientes
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Clientes
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais clientes ({{
                    this.listOfCustomers.length
                    }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Clientes </label>
                          <v-select
                            v-model="filter.customers"
                            label="name"
                            :options="listOfCustomers"
                            name="customers"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10">
                <a href="#" class="dd-link" data-toggle="dropdown">
                  <div v-if="filter.steps.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-flag tx-info mg-r-5"></i>Etapas:
                      <span
                        class="pd-x-5 badge mg-b-0 mg-r-2-force tx-thin-force"
                        :style="
                          'background: ' +
                          c.color +
                          '; color: ' +
                          c.textColor +
                          ' !important;'
                        "
                        v-for="c in filter.steps"
                        :key="c.id"
                      >
                        {{ c.description }}
                      </span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span
                    ><i class="fa fa-flag tx-medium mg-r-5"></i> Etapas
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Etapas
                  </h6>
                  <p class="tx-gray-600 mg-b-10">Selecione um ou mais etapas</p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Etapas </label>
                          <v-select
                            v-model="filter.steps"
                            label="name"
                            :options="steps"
                            name="steps"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.description }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link" data-toggle="dropdown">
                  <div v-if="filter.customsBrokers.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="icon ion-person-stalker tx-teal mg-r-5"></i
                      >Despachantes:
                      <span
                        class="pd-x-5 badge badge-teal mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="cb in filter.customsBrokers"
                        :key="cb.id"
                      >
                        {{ cb.name }}
                      </span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>
                  <div v-else>
                    <span
                    ><i class="icon ion-person-stalker tx-medium mg-r-5"></i>
                      Despachantes
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Despachante Aduaneiro
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais despachantes aduaneiros ({{
                    this.listOfCustomsBrokers.length
                    }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label">
                            Despachante Aduaneiro
                          </label>
                          <v-select
                            v-model="filter.customsBrokers"
                            label="name"
                            :options="listOfCustomsBrokers"
                            name="customsBrokers"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link" data-toggle="dropdown">
                  <div v-if="filter.exporters.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="icon ion-person-stalker tx-indigo mg-r-5"></i
                      >Exportadores:
                      <span
                        class="pd-x-5 badge badge-indigo mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="cb in filter.exporters"
                        :key="cb.id"
                      >
                        {{ cb.name }}
                      </span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>
                  <div v-else>
                    <span
                    ><i class="icon ion-person-stalker tx-medium mg-r-5"></i>
                      Exportadores
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-0">
                    Exportadores
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais Exportadores ({{
                    this.listOfExporters.length
                    }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label">
                            Exportadores
                          </label>
                          <v-select
                            v-model="filter.exporters"
                            label="name"
                            :options="listOfExporters"
                            name="exporters"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link" data-toggle="dropdown">
                  <div v-if="filter.teams.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="icon ion-person-stalker tx-pink mg-r-5"></i
                      >Times Operacionais:
                      <span
                        class="pd-x-5 badge badge-pink mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="t in filter.teams"
                        :key="t.id"
                      >
                        {{ t.name }}
                      </span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>
                  <div v-else>
                    <span
                    ><i class="icon ion-person-stalker tx-medium mg-r-5"></i>
                      Times Operacionais
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>

                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-0">
                    Times Operacionais
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais Times Operacionais ({{ this.listOfTeams.length }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Times Operacionais </label>
                          <v-select
                            v-model="filter.teams"
                            label="name"
                            :options="listOfTeams"
                            name="teams"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link" data-toggle="dropdown">
                  <div v-if="filter.customsTeams.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="icon ion-person-stalker tx-pink mg-r-5"></i>
                      Times Aduaneiros:
                      <span
                        class="pd-x-5 badge badge-pink mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="ct in filter.customsTeams"
                        :key="ct.id"
                      >
                        {{ ct.name }}
                      </span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>
                  <div v-else>
                    <span
                    ><i class="icon ion-person-stalker tx-medium mg-r-5"></i>
                      Times Aduaneiros
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>

                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-0">
                    Times Aduaneiros
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais Times Aduaneiros ({{
                      this.listOfCustomsTeams.length
                    }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Times Aduaneiros </label>
                          <v-select
                            v-model="filter.customsTeams"
                            label="name"
                            :options="listOfCustomsTeams"
                            name="customsTeams"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link" data-toggle="dropdown">
                  <div v-if="filter.retreatIcms.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fas fa-bank mg-r-5"></i>Recolhimento ICMS:
                      <span
                        class="pd-x-5 badge badge-pink mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="t in filter.retreatIcms"
                        :key="t.value"
                      >
                        {{ t.value }}
                      </span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>
                  <div v-else>
                    <i class="fas fa-bank mg-r-5"></i>Recolhimento ICMS
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>

                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-0">
                    Opções de recolhimento
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um opção ({{ retreatIcmsOptions.length }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label">
                            Alíquotas de ICMS
                          </label>
                          <v-select
                            v-model="filter.retreatIcms"
                            label="label"
                            :options="retreatIcmsOptions"
                            name="retreatIcms"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.label }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.accounts.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-building tx-danger mg-r-5"></i>Empresas Importadoras:
                      <span
                        class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="c in filter.accounts"
                        :key="c.id"
                      >
                        {{ c.name }}</span
                      >
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span
                    ><i class="fa fa-building tx-medium mg-r-5"></i> Empresas Importadoras
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Empresas Importadoras
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione uma ou mais empresas importadoras ({{
                    this.listOfAccount.length
                    }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Empresas Importadoras </label>
                          <v-select
                            v-model="filter.accounts"
                            label="name"
                            :options="listOfAccount"
                            name="accounts"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.typeOfProcess.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-flag tx-info mg-r-5"></i>Tipos de Processos:
                      <span
                        class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="c in filter.typeOfProcess"
                        :key="c.id"
                      >
                        {{ c.name }}</span
                      >
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span
                    ><i class="fa fa-flag tx-medium mg-r-5"></i> Tipos de Processos
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Tipos de Processos
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais tipos de processos ({{
                    this.listOfTypeOfProcess.length
                    }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Tipos de Processos </label>
                          <v-select
                            v-model="filter.typeOfProcess"
                            label="name"
                            :options="listOfTypeOfProcess"
                            name="typeOfProcess"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
			<li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.priority">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-flag tx-info mg-r-5"></i>Prioridade:
						<span class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force">
							{{ filter.priority.name }}
						</span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>
                  <div v-else>
                    <span><i class="fa fa-flag tx-medium mg-r-5"></i> Prioridade</span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Prioridade
                  </h6>
				  <p class="tx-gray-600 mg-b-10">
                    Selecione para filtrar se no processo tem ou não prioridade
                  </p>
                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Prioridade </label>
                          <v-select
                            v-model="filter.priority"
                            label="name"
                            :options="listOfPriority"
                            name="priority"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
			<li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.priorityTypes.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-flag tx-info mg-r-5"></i>Tipos de Prioridade:
                      <span
                        class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="c in filter.priorityTypes"
                        :key="c.id"
                      >
                        {{ c.name }}</span
                      >
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span
                    ><i class="fa fa-flag tx-medium mg-r-5"></i> Tipos de Prioridade
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Tipos de Prioridade
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais tipos de prioridade ({{ this.listOfPriorityTypes.length }} encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Tipos de Prioridade </label>
                          <v-select
                            v-model="filter.priorityTypes"
                            label="name"
                            :options="listOfPriorityTypes"
                            name="priorityTypes"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo mg-l-10" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.diChannels.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-flag tx-info mg-r-5"></i>Canal DI/DUIMP:
                      <span
                        class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="c in filter.diChannels"
                        :key="c.id"
                      >
                        {{ c.name }}</span
                      >
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span
                    ><i class="fa fa-flag tx-medium mg-r-5"></i> Canal DI/DUIMP
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Canal DI/DUIMP
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais canais ({{
                    this.listOfDiChannels.length
                    }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Canal DI/DUIMP </label>
                          <v-select
                            v-model="filter.diChannels"
                            label="name"
                            :options="listOfDiChannels"
                            name="diChannel"
                            multiple
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <ul class="nav nav-white-800 flex-column flex-md-row tx-white tx-15">
            <li class="mg-l-10">
              <div class="btn-group" role="group" aria-label="Ações">
                <button
                  type="button"
                  class="btn btn-primary pd-x-20 mg-r-10"
                  @click.prevent="generate('HTML')"
                >
                  <i class="fa fa-play mg-r-5"></i> GERAR
                </button>
                <button
                  type="button"
                  class="btn btn-secondary pd-x-20 mg-r-10"
                  v-if="
                    listOfResults.length > 0 &&
                    filter.date.field.attribute === 'diRegistryDate'
                  "
                  @click.prevent="getXmlDis"
                >
                  <i class="fa fa-file-code-o mg-r-5"></i> Gerar ZIP com XML das
                  DIs
                </button>
                <button
                  type="button"
                  class="btn btn-danger pd-x-20 mg-r-10"
                  v-if="listOfResults.length > 0"
                  @click.prevent="generate('PDF')"
                >
                  <i class="fa fa-file-pdf-o mg-r-5"></i>
                  PDF
                </button>
                <download-excel
                  :data="listOfResultsExel"
                  :fields="excelColumns"
                  class="btn btn-success pd-x-20"
                  v-if="listOfResultsExel.length > 0"
                  :name="`relatorio-geral-de-importacoes.xls`"
                >
                  <i class="far fa-file-excel mg-r-5"></i>
                  EXCEL
                </download-excel>
              </div>
            </li>
          </ul>
        </div>

        <div class="section-wrapper mg-t-0 pd-0 bd-1 bd-l-0 bd-r-0 bd-b-1">
          <div class="pd-10 mg-10">
            <div class="flex ai-c jc-sb fgap2">
              <div>
                <label class="section-title mg-t-10 tx-16">
                  Resultado da Consulta</label
                >
                <p class="mg-b-0">
                  Foram encontrados {{ listOfResults.length }} Processos de
                  Importação de acordo com o filtro acima.
                  <router-link
                    :to="{
                      path: `/operational/imp/desk?stepsIds=8&processesIds=${processesIdsToList}&columns=identification,account,step,customer,exporter,invoice,customerRef,customsEnclosure,billOfLading,datesETA,datesETD,datesDepartureDate,datesArrivalDate,diRegistryDate,diNumber,diResourcefulnessDate,diChannel&showProcess=true&indicatorProcess=true`,
                    }"
                    target="_blank"
                    class="statement-link"
                  >Visualizar os processos no Telão de Importação
                    <i class="fa fa-angle-right mg-l-5"></i
                    ></router-link>
                </p>
              </div>

              <div class="d-flex align-items-center flex-wrap">
                <button
                  type="button"
                  class="btn btn-outline-primary pd-x-20 mg-r-10"
                  title="Salvar"
                  @click.prevent="handleSaveDeskState"
                >
                  <i class="icon fa fa-save tx-bold"></i>
                  <span class="mg-l-5">Salvar</span>
                </button>
                <div ref="profileDropdown" class="dropdown dropdown-a dropleft mg-r-10 d-inline-block">
                  <button
                    type="button"
                    class="btn btn-outline-primary pd-x-20 dropdown-toggle"
                    :title="profileButtonTitle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="icon ion-person-stalker"></i>
                    <span class="mg-l-5">{{ profileButtonLabel }}</span>
                  </button>
                  <div
                    class="dropdown-menu dropdown-media-list wd-450"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div class="dropdown-menu-header">
                      <label>Perfis Cadastrados ({{ deskStates.length }})</label>
                      <a
                        href="#"
                        class="tx-12"
                        @click.prevent="handleSaveDeskState"
                      >+ SALVAR PERFIL</a>
                    </div>
                    <div
                      class="list-group list-group-striped list-group-user bd-t-0--force"
                    >
                      <template v-if="deskStates.length > 0">
                        <div
                          class="list-group-item"
                          :class="{ 'profile-item-active': isActiveDeskState(state) }"
                          :key="'desk-state-' + index"
                          v-for="(state, index) in deskStates"
                        >
                          <div
                            class="user-name-address mg-0"
                            @click="selectDeskState(state)"
                          >
                            <p>{{ state.name }}</p>
                            <span>{{ state.created | moment("DD/MM/YYYY") }}</span>
                          </div>
                          <div class="user-btn-wrapper">
                            <a
                              href="#"
                              class="btn btn-outline-danger btn-icon"
                              @click.prevent="deleteDeskState(state)"
                            >
                              <div class="tx-18">
                                <i class="icon ion-trash-a"></i>
                              </div>
                            </a>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="media-body">
                          <p class="pd-10 tx-center">
                            Nenhum perfil foi cadastrado.
                          </p>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-primary pd-x-20"
                  @click.prevent="openDrawer"
                >
                  ORGANIZAR COLUNAS
                </button>
              </div>
            </div>

            <hr/>

            <div class="table-responsive">
              <table class="table table-striped mg-b-0 tx-gray-800 tx-12">
                <thead>
					<tr>
						<th v-for="col in enabledTableColumns" :key="col.field" class="tx-center">
							{{ col.alt || col.label }}
						</th>
					</tr>
                </thead>
                <tbody>
					<tr v-for="result in listOfResults" :key="result.id">
						<td v-for="col in enabledTableColumns" :key="col.field" class="tx-center">
							<template v-if="col.otherField">
								<span>	
									{{ otherField(result, col) }}
								</span>
							</template>
							<template v-else-if="col.priorityField">
								<span>	
									{{ priorityField(result, col) }}
								</span>
							</template>
							<template v-else-if="col.typeOptions">
								<span>
									{{ (col.typeOptions && col.typeOptions[traverse(result, col.field)]) || traverse(result, col.field) }}
								</span>
							</template>
							<template v-else-if="col.teamByTypeOfProcess">
								<span>{{ teamField(result, col) }}</span>
							</template>
							<template v-else-if="col.field === 'typeOfBoarding'">
								<span>{{ formatTypeOfBoarding(result) }}</span>
							</template>
							<template v-else-if="col.dateField">
								<span>{{ formatYesOrCheckDate(result, col) }}</span>
							</template>
							<template v-else-if="result[col.field.split('.')[0]]">
								<span v-if="col.type === 'default'">
									{{ traverse(result, col.field) }}
								</span>
								<a href="#" @click.prevent="findProcessByIdentificationSearch(traverse(result, col.field))" v-if="col.type === 'identification'">
									{{ getTypeOfProcessReference(result) }}
								</a>
								<span v-else-if="col.type === 'money'">
									{{ Number(traverse(result, col.field)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) }}
								</span>
								<span v-else-if="col.type === 'boolean' && !col?.typeValue">
									{{ traverse(result, col.field) ? "Sim" : "Não" }}
								</span>
								<span v-else-if="col.type === 'count'">
									{{ result[col.field].length || 0 }}
								</span>
								<span v-else-if="col.type === 'boolean' && col?.typeValue">
									{{ col.typeValue[traverse(result, col.field)] || traverse(result, col.field) }}
								</span>
								<span v-else-if="col.type === 'date'">
									{{ traverse(result, col.field) | moment("DD/MM/YYYY") }}
								</span>
								<span v-else-if="col.type === 'datetime'">
									{{ traverse(result, col.field) | moment("DD/MM/YYYY HH:mm:ss") }}	
								</span>
								<span v-else-if="col.type === 'array'">
									{{
										(() => {
											const arrayValue = traverse(result, col.field);
											if (!arrayValue || !Array.isArray(arrayValue) || arrayValue.length === 0) {
												return 'N/I';
											}
											const mapped = arrayValue.map(item => item && item[col.arrayField]).filter(Boolean);
											return mapped.length > 0 ? mapped.join(', ') : 'N/I';
										})()
									}}
								</span>
							</template>
							<span v-else-if="col.type === 'boolean' && !col?.typeValue"> Não </span>
							<span v-else-if="col.type === 'boolean' && col?.typeValue && col?.typeValueDefault"> {{ col.typeValueDefault }} </span>
							<span v-else-if="col.type === 'default' && col?.typeValueDefault"> {{ col.typeValueDefault }} </span>
							<span v-else> N/I</span>
						</td>
					</tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :preview-modal="true"
      :enable-download="false"
      :filename="'Relatório_De_Atividades'"
      pdf-orientation="landscape"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="report-box">
          <table cellpadding="0" cellspacing="0">
            <tr class="report-top">
              <td colspan="2">
                <table class="report-header">
                  <tr>
                    <td class="report-header-left">
                      <strong>
                        Prime Internacional Comércio Exterior LTDA
                      </strong>
                      <br/>
                      CNPJ: 08214494000119
                      <br/>
                      Inscrição Municipal: 285459-0 / IE: 255.232.322
                      <br/>
                      Matriz: Itajaí / SC
                      <br/>
                    </td>
                    <td
                      class="report-header-right"
                      align="right"
                      valign="middle"
                    >
                      <img
                        src="@/assets/img/logo-horizontal-azul.png"
                        style="width: 190px"
                      />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td colspan="2">
                <br/>
                <h1 class="report-slim-pagetitle">
                  RELATÓRIO GERAL DE IMPORTAÇÕES
                </h1>
              </td>
            </tr>
          </table>

          <div
            class="flex ai-c fgap1 text-bold p-2 mb-2"
            style="
              background-color: var(--shortcut-round-bg);
              border-radius: 10px;
            "
          >
            <template v-for="(col, index) in enabledTableColumns">
              <div
                v-if="index < 10"
                :key="col.field"
                :style="{
                  flex: `0 1 ${100 / enabledTableColumns.length}%`,
                  fontSize: '11px',
                  textAlign: 'center',
                  lineHeight: '14px',
                }"
              >
                {{ col.label }}
              </div>
            </template>
          </div>

          <div style="border-radius: 10px; overflow: hidden">
            <div
              v-for="(result, index) in listOfResults"
              :key="result.id"
              class="flex ai-c fgap1 p-1"
              :style="{
                backgroundColor: index % 2 === 0 ? '#f5f6f7' : 'white',
              }"
            >
              <!--                  <div class="html2pdf__page-break" v-if="index !== 0 && index % 6 === 0" style="margin-top: 10px;"/>-->
              <template v-for="(col, index) in enabledTableColumns">
                <div
                  v-if="index < 10"
                  :key="col.field"
                  class="report-tx-center"
                  :style="{
                    flex: `0 1 ${100 / enabledTableColumns.length}%`,
                    fontSize: '10px',
                    lineHeight: '14px',
                  }"
                >
					<template v-if="col.otherField">
						<span>	
							{{ otherField(result, col) }}
						</span>
					</template>
					<template v-else-if="col.priorityField">
						<span>	
							{{ priorityField(result, col) }}
						</span>
					</template>
					<template v-else-if="col.typeOptions">
						<span>
							{{ (col.typeOptions && col.typeOptions[traverse(result, col.field)]) || traverse(result, col.field) }}
						</span>
					</template>
					<template v-else-if="col.teamByTypeOfProcess">
						<span>{{ teamField(result, col) }}</span>
					</template>
					<template v-else-if="col.field === 'typeOfBoarding'">
						<span>{{ formatTypeOfBoarding(result) }}</span>
					</template>
					<template v-else-if="col.dateField">
						<span>{{ formatYesOrCheckDate(result, col) }}</span>
					</template>
					<template v-else-if="result[col.field.split('.')[0]]">
						<span v-if="col.type === 'default'">
							{{ fildtype(result, col) }}
						</span>
						<span v-else-if="col.type === 'identification'">
							{{ traverse(result, col.field) }}
						</span>
						<span v-else-if="col.type === 'money'">
							{{ Number(traverse(result, col.field)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) }}
						</span>
						<span v-else-if="col.type === 'boolean' && !col?.typeValue">
							{{ traverse(result, col.field) ? "Sim" : "Não" }}
						</span>
						<span v-else-if="col.type === 'count'">
							{{ result[col.field].length || 0 }}
						</span>
						<span v-else-if="col.type === 'boolean' && col?.typeValue">
							{{ col.typeValue[traverse(result, col.field)] || traverse(result, col.field) }}
						</span>
						<span v-else-if="col.type === 'date'">
							{{ fildtype(result, col) }}
						</span>
						<span v-else-if="col.type === 'datetime'">
							{{ traverse(result, col.field) | moment("DD/MM/YYYY HH:mm:ss") }}
						</span>
						<span v-else-if="col.type === 'array'">
							{{
								(() => {
									const arrayValue = traverse(result, col.field);
									if (!arrayValue || !Array.isArray(arrayValue) || arrayValue.length === 0) {
										return 'N/I';
									}
									const mapped = arrayValue.map(item => item && item[col.arrayField]).filter(Boolean);
									return mapped.length > 0 ? mapped.join(', ') : 'N/I';
								})()
							}}
						</span>
					</template>
					<span v-else-if="col.type === 'boolean' && !col?.typeValue"> Não </span>
					<span v-else-if="col.type === 'boolean' && col?.typeValue && col?.typeValueDefault"> {{ col.typeValueDefault }} </span>
					<span v-else-if="col.type === 'default' && col?.typeValueDefault"> {{ col.typeValueDefault }} </span>
					<span v-else> N/I</span>
                </div>
              </template>
            </div>
          </div>

          <div class="report-footer">
            <small> </small>
            <br/>
          </div>
        </div>
      </section>
    </vue-html2pdf>

    <VDrawer :minWidth="700" @requestClose="closeDrawer" :handler="drawerOpen">
      <template #header>Organizar Colunas</template>

      <template #content>
        <div class="mb-3">
          <h6 class="slim-pagetitle">Colunas Disponíveis</h6>
          <span class="subtitle"
          >Selecione na coluna direita e ordene na coluna esquerda.</span
          >
        </div>

        <div class="flex jc-sb fgap2">
          <div style="flex: 0 1 50%">
            <h6 class="text-dark">Colunas Habilitadas</h6>

            <Draggable
              v-model="tableColumns"
              class="columns-list active list-group w-100"
            >
              <template v-for="col in tableColumns">
                <li
                  v-if="col.enabled == true"
                  @click.prevent="disableTableColumn(col.field)"
                  class="list-group-item list-group-item-action"
                  :key="col.field"
                >
                  {{ col.label }}
                </li>
              </template>
            </Draggable>
          </div>

          <div style="flex: 0 1 50%">
            <h6 class="text-dark">Colunas Desabilitadas</h6>

            <ul class="columns-list list-group w-100">
              <li class="p-0">
                <input
                  class="wd-100p form-control"
                  type="search"
                  name="searchInTable"
                  id="searchInTable"
                  placeholder="Pesquisar coluna..."
                  v-model="disabledColumnsSearch"
                />
              </li>
              <template v-for="col in filteredTableColumns">
                <li
                  v-if="col.enabled == false"
                  @click.prevent="enableTableColumn(col.field)"
                  class="list-group-item list-group-item-action"
                  :key="col.field"
                >
                  {{ col.label }}
                </li>
              </template>
            </ul>
          </div>
        </div>
      </template>

      <template #footer>
        <div>
          <button
            type="button"
            class="w-100 btn btn-primary pd-x-20 mg-r-10"
            @click.prevent="resetTableColumns"
          >
            REDEFINIR COLUNAS
          </button>
        </div>
      </template>
    </VDrawer>
  </div>
</template>

<script>
import Axios from "axios";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import config from "@/config.js";
import * as labelsProcesses from "@/labels/labels.processes.js";
import VueHtml2pdf from "vue-html2pdf";
import {mapState} from "vuex";
import moment from "moment";
import {processColumns} from "@/utils/process/processColumns.js";
import { formatTypeOfBoarding as formatTypeOfBoardingValue } from "@/utils/formatTypeOfBoarding.js";
import VDrawer from "@/components/VDrawer.vue";
import Draggable from "vuedraggable";
import JsonExcel from "vue-json-excel";
import * as constants from "@/consts.js";
import ProcessService from "@/services/ProcessService.js";
import { EventBus } from "@/events/EventBus.js";
import DeskStateModal from "@/views/operational/imp/Desk.State.Modal.vue";

export default {
  name: "OperationalGeneral",
  props: [],
  components: {
    DatePicker,
    VueHtml2pdf,
    VDrawer,
    Draggable,
    "download-excel": JsonExcel,
    "desk-state-modal": DeskStateModal,
  },
  data() {
    return {
      drawerOpen: false,
      deskStates: [],
      activeDeskStateKey: null,
      modal: {
        deskState: {
          show: false,
        },
      },
      tableColumns: processColumns,
      disabledColumnsSearch: "",
      filter: {
        steps: [],
        exporters: [],
        customers: [],
        customsBrokers: [],
        retreatIcms: [],
        teams: [],
        customsTeams: [],
        accounts: [],
        typeOfProcess: [],
        diChannels: [],
		priorityTypes: [],
		priority: null,
		drawback: null,
        date: {
          field: "",
          start: moment().startOf("week").toDate(),
          end: moment().endOf("week").toDate(),
        },
      },
      retreatIcmsOptions: [
        {
          value: 2.5,
          label: "2.5",
        },
      ],
      processesIdsToList: "",
      labels: {
        id: {
          label: "ID",
        },
        ...labelsProcesses.reportModifyLabels(),
      },
      listOfCustomsBrokers: [],
      listOfCustomers: [],
      listOfExporters: [],
      listOfResults: [],
      listOfResultsExel: [],
      listOfTeams: [],
      listOfCustomsTeams: [],
      listOfTypeOfProcess: [],
      listOfDiChannels: [],
      listOfAccount: [],
	  listOfPriorityTypes: [],
	  listOfPriority: [ { id: true , name: "Sim" }, { id: false, name: "Não" } ],
	  listOfDrawback: [ { id: true , name: "Sim" }, { id: false, name: "Não" } ],
    };
  },

  methods: {
    handleSaveDeskState() {
      if (!this.activeDeskState) {
        this.openCreateDeskStateModal();
        return;
      }

      Swal.fire({
        title: "Salvar perfil",
        html: `Perfil ativo: <strong>${this.activeDeskState.name}</strong><br><br>Deseja salvar no perfil atual ou criar um novo?`,
        type: "question",
        showCancelButton: true,
		showCloseButton: true,
        confirmButtonText: "Salvar no perfil atual",
        cancelButtonText: "Criar novo perfil",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.updateActiveDeskState();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.openCreateDeskStateModal();
        }
      });
    },
    openCreateDeskStateModal() {
      this.modal.deskState.show = true;
    },
    closeModalDeskState() {
      this.modal.deskState.show = false;
    },
    async updateActiveDeskState() {
      const state = this.activeDeskState;
      if (!state) return;

      try {
        this.$store.commit("setLoading", {
          show: true,
          label: "Perfis",
          description: `Atualizando o perfil ${state.name}...`,
        });

        const payload = {
          name: state.name,
          processType: "IMPORT",
          context: "REPORT_IMP_GENERAL",
          steps: JSON.stringify(this.reportDeskSteps),
          columns: JSON.stringify(this.tableColumns),
          filter: JSON.stringify(this.filter),
        };

        await Axios.put(
          `${config.env.API_DEFAULT.host}/desk/states/${state.id}`,
          payload
        );

        EventBus.$emit("operational.imp.Desk.loadDeskStates");

        Swal.fire(
          "Perfis",
          `O perfil <strong>${state.name}</strong> foi atualizado com sucesso!`,
          "success"
        );
      } catch (error) {
        Swal.fire("Perfis", error.message, "error");
      } finally {
        this.$store.commit("setLoading", {
          show: false,
        });
      }
    },
    isReportFilter(filter) {
      return (
        filter &&
        filter.date !== undefined &&
        filter.selectedDateRange === undefined
      );
    },
    isReportColumns(columns) {
      return (
        Array.isArray(columns) &&
        columns.length > 0 &&
        typeof columns[0] === "object" &&
        columns[0].field
      );
    },
    normalizeReportFilterDates(filter) {
      const normalized = {
        ...filter,
        date: { ...(filter.date || {}) },
      };

      if (normalized.date.start) {
        normalized.date.start = new Date(normalized.date.start);
      }

      if (normalized.date.end) {
        normalized.date.end = new Date(normalized.date.end);
      }

      return normalized;
    },
    mergeReportColumns(savedColumns) {
      if (!savedColumns || !Array.isArray(savedColumns)) {
        return processColumns;
      }

      const savedByField = {};
      savedColumns.forEach((col) => {
        if (col && col.field) {
          savedByField[col.field] = col;
        }
      });

      const merged = savedColumns
        .filter(
          (col) =>
            col &&
            col.field &&
            processColumns.some((baseCol) => baseCol.field === col.field)
        )
        .map((col) => {
          const baseCol = processColumns.find(
            (processCol) => processCol.field === col.field
          );
          return {
            ...baseCol,
            ...col,
            field: col.field,
          };
        });

      processColumns.forEach((col) => {
        if (!savedByField[col.field]) {
          merged.push({
            ...col,
            enabled: false,
          });
        }
      });

      return merged;
    },
    mapReportFilterToDeskFilter(reportFilter) {
      return {
        selectedDateRange: {
          from: reportFilter.date?.start || "",
          to: reportFilter.date?.end || "",
        },
        selectedDateField: reportFilter.date?.field || "",
        selectedTeams: reportFilter.teams || [],
        selectedCustomsTeams: reportFilter.customsTeams || [],
        selectedCustomsBrokers: reportFilter.customsBrokers || [],
        selectedImportLicenses: null,
        selectedWaysOfTransport: [],
        selectedIncoterms: [],
        selectedCustomsEnclosuresIds: [],
        selectedDiChannels: reportFilter.diChannels || [],
        selectedTypesOfProcess: reportFilter.typeOfProcess || [],
        selectedPriorityTypes: reportFilter.priorityTypes || [],
        selectedPriority: reportFilter.priority || null,
        selectedUrgent: null,
        selectedRadarModality: null,
      };
    },
    mapReportColumnsToDeskColumns(reportColumns) {
      const deskKeys = [];
      const added = new Set();

      reportColumns
        .filter((col) => col.enabled)
        .forEach((col) => {
          const deskKey = col.field.includes(".")
            ? col.field.split(".")[0]
            : col.field;

          if (!added.has(deskKey)) {
            deskKeys.push(deskKey);
            added.add(deskKey);
          }
        });

      return deskKeys;
    },
    mapDeskFilterToReportFilter(deskFilter, deskSteps) {
      const reportFilter = {
        steps: [],
        exporters: [],
        customers: [],
        customsBrokers: [],
        retreatIcms: [],
        teams: [],
        customsTeams: [],
        accounts: [],
        typeOfProcess: [],
        diChannels: [],
        priorityTypes: [],
        priority: null,
        drawback: null,
        date: {
          field: "",
          start: moment().startOf("week").toDate(),
          end: moment().endOf("week").toDate(),
        },
      };

      if (!deskFilter) {
        if (deskSteps && Array.isArray(deskSteps) && this.steps) {
          const stepIds = deskSteps.map((item) => parseInt(item, 10));
          reportFilter.steps = this.steps.filter((step) =>
            stepIds.includes(step.id)
          );
        }
        return reportFilter;
      }

      if (deskFilter.selectedDateField) {
        reportFilter.date.field = deskFilter.selectedDateField;
      }

      if (deskFilter.selectedDateRange) {
        if (deskFilter.selectedDateRange.from) {
          reportFilter.date.start = new Date(deskFilter.selectedDateRange.from);
        }
        if (deskFilter.selectedDateRange.to) {
          reportFilter.date.end = new Date(deskFilter.selectedDateRange.to);
        }
      }

      reportFilter.teams = deskFilter.selectedTeams || [];
      reportFilter.customsTeams = deskFilter.selectedCustomsTeams || [];
      reportFilter.customsBrokers = deskFilter.selectedCustomsBrokers || [];
      reportFilter.typeOfProcess = deskFilter.selectedTypesOfProcess || [];
      reportFilter.diChannels = deskFilter.selectedDiChannels || [];
      reportFilter.priorityTypes = deskFilter.selectedPriorityTypes || [];
      reportFilter.priority = deskFilter.selectedPriority || null;

      if (deskSteps && Array.isArray(deskSteps) && this.steps) {
        const stepIds = deskSteps.map((item) => parseInt(item, 10));
        reportFilter.steps = this.steps.filter((step) =>
          stepIds.includes(step.id)
        );
      }

      return reportFilter;
    },
    mapDeskColumnsToReportColumns(deskColumns) {
      if (!deskColumns || !Array.isArray(deskColumns) || deskColumns.length === 0) {
        return processColumns;
      }

      const deskKeys = deskColumns.map((col) =>
        typeof col === "string" ? col : col.field || col
      );
      const merged = [];
      const addedFields = new Set();

      const matchesDeskKey = (field, deskKey) => {
        if (field === deskKey) {
          return true;
        }
        return field.split(".")[0] === deskKey;
      };

      deskKeys.forEach((deskKey) => {
        processColumns.forEach((col) => {
          if (matchesDeskKey(col.field, deskKey) && !addedFields.has(col.field)) {
            merged.push({ ...col, enabled: true });
            addedFields.add(col.field);
          }
        });
      });

      processColumns.forEach((col) => {
        if (!addedFields.has(col.field)) {
          merged.push({ ...col, enabled: false });
        }
      });

      return merged;
    },
    getDeskStateKey(state) {
      if (state && state._links && state._links.self && state._links.self.href) {
        return state._links.self.href;
      }
      return state.id;
    },
    isActiveDeskState(state) {
      return this.activeDeskStateKey === this.getDeskStateKey(state);
    },
    selectDeskState(state) {
      if (this.isReportFilter(state.filter)) {
        this.filter = this.normalizeReportFilterDates(state.filter);

        if (
          state.steps &&
          Array.isArray(state.steps) &&
          (!this.filter.steps || this.filter.steps.length === 0)
        ) {
          const stepIds = state.steps.map((item) => parseInt(item, 10));
          this.filter.steps = this.steps.filter((step) =>
            stepIds.includes(step.id)
          );
        }
      } else {
        this.filter = this.mapDeskFilterToReportFilter(
          state.filter,
          state.steps
        );
      }

      if (state.columns !== null && state.columns !== undefined) {
        this.tableColumns = this.isReportColumns(state.columns)
          ? this.mergeReportColumns(state.columns)
          : this.mapDeskColumnsToReportColumns(state.columns);
      }

      this.listOfResults = [];
      this.listOfResultsExel = [];
      this.processesIdsToList = "";
      this.activeDeskStateKey = this.getDeskStateKey(state);
      this.closeProfileDropdown();
      Swal.fire({
        title: `Perfil "${state.name}" aplicado`,
        html: "Clique em <strong>GERAR</strong> para consultar.",
        icon: "success",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
      });
    },
    closeProfileDropdown() {
      const dropdown = this.$refs.profileDropdown;
      if (!dropdown) return;

      dropdown.classList.remove("show");
      const menu = dropdown.querySelector(".dropdown-menu");
      if (menu) menu.classList.remove("show");
      const toggle = dropdown.querySelector('[data-toggle="dropdown"]');
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    },
    deleteDeskState(state) {
      Swal.fire({
        title: "Você tem certeza?",
        html: `Se você excluir o perfil <strong>${state.name}</strong>, não será possível recuperá-lo para uso posterior.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((willContinue) => {
        if (willContinue.value) {
          this.$store.commit("setLoading", {
            show: true,
            label: "Perfis",
            description: `Excluindo o perfil ${state.name}...`,
          });

          Axios.delete(
            `${config.env.API_DEFAULT.host}/desk/states/${state.id}`
          )
            .then(() => {
              this.$store.commit("setLoading", {
                show: false,
              });
              if (this.isActiveDeskState(state)) {
                this.activeDeskStateKey = null;
              }
              Swal.fire(
                "Perfis",
                `O perfil <strong>${state.name}</strong> foi excluído com sucesso!`,
                "success"
              );
              this.loadDeskStates();
            })
            .catch((error) => {
              this.$store.commit("setLoading", {
                show: false,
              });
              if (error.response && error.response.status === 409) {
                Swal.fire(
                  "Perfis",
                  "Não foi possível excluir o perfil, porque ele já está em uso.",
                  "error"
                );
              } else {
                Swal.fire("Perfis", error.message, "error");
              }
            });
        }
      });
    },
    loadDeskStates() {
      this.$store.commit("setLoading", {
        show: true,
        label: "Perfis",
        description: "Carregando os perfis cadastrados...",
      });

      Axios.get(
        `${config.env.API_DEFAULT.host}/desk/states?context=REPORT_IMP_GENERAL`
      )
        .then((response) => {
          this.deskStates = response.data.data || [];
          this.$store.commit("setLoading", {
            show: false,
          });
        })
        .catch((error) => {
          this.$store.commit("setLoading", {
            show: false,
          });
          Swal.fire(
            "Perfis",
            `Houve algum problema ao tentar carregar os perfis: ${error.response}`,
            "error"
          );
        });
    },
    normalizeColumnSearchText(str) {
      if (str == null) return "";
      return String(str)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
	async getPriorityTypes() {
		Axios.get(`${config.env.API_DEFAULT.host}//newImportProcess/priority-types`)
		.then((response) => {
			this.listOfPriorityTypes = response.data.data.map((item) => ({id: item.id, name: item.description}));
		});

	},
    keepOpen(event) {
      event.preventDefault();
      if (event.target && (event.target.tagName === 'A' || event.target.tagName === 'UL')) {
        const dropdowns = document.querySelectorAll('.dropdown-menu');
        dropdowns.forEach((dropdown) => {
          dropdown.classList.remove('show');
        });
      } 
    },
    openDrawer() {
      this.drawerOpen = true;
    },
    closeDrawer() {
      this.drawerOpen = false;
    },
    getTypeOfProcessReference(process) {
      return ProcessService.getTypeOfProcessReference(process);
    },
    enableTableColumn(field) {
      this.tableColumns = this.tableColumns.map((col) => {
        if (col.field === field) {
          return {
            ...col,
            enabled: true,
          };
        }
        return col;
      });
    },
    disableTableColumn(field) {
      this.tableColumns = this.tableColumns.map((col) => {
        if (col.field === field) {
          return {
            ...col,
            enabled: false,
          };
        }
        return col;
      });
    },
    resetTableColumns() {
      this.tableColumns = processColumns;
    },
    traverse(obj, keys) {
      return keys.split(".").reduce((cur, key) => cur[key], obj);
    },
	otherField(result, col) {
		if (col.otherField) {
			// Itera sobre cada entrada no objeto otherField
			for (const [fieldToCheck, conditions] of Object.entries(col.otherField)) {
				// Verifica se todas as condições são atendidas
				const allConditionsMet = Object.entries(conditions).every(([key, value]) => {
					return result[key] === value;
				});

				// Se todas as condições forem atendidas, retorna o valor do campo
				if (allConditionsMet) {
					const newCol = {
						field: fieldToCheck,
						type: col.type,
						typeValue: col.typeValue
					};
					return this.fildtype(result, newCol);
				}
			}
			// Se nenhuma condição for atendida, retorna o campo original
			return this.fildtype(result, col);
		}
		return this.fildtype(result, col);
	},
	priorityField(result, col) {
		if (col.priorityField) {
			// Itera sobre cada entrada no objeto priorityField
			for (const [entityKey, propertyName] of Object.entries(col.priorityField)) {
				// Verifica se a entidade existe no result
				if (result[entityKey]) {
					// Acessa a propriedade dentro da entidade
					const value = result[entityKey][propertyName];
					if (value !== undefined && value !== null) {
						// Cria um novo objeto col com o campo correto para formatação
						const newCol = {
							field: `${entityKey}.${propertyName}`,
							type: col.type,
							typeValue: col.typeValue
						};
						return this.fildtype(result, newCol);
					}
				}
			}
			// Se não encontrou nenhum valor, retorna o campo original
			return this.fildtype(result, col);
		}
		return this.fildtype(result, col);
	},
	/**
	 * Retorna o nome do time operacional do processo conforme o tipo de processo.
	 * O time é obtido do customer: CONTA_E_ORDEM → customer.team, ASSESSORIA → customer.teamAdvisory, ENCOMENDA → customer.teamOrder.
	 * @param {Object} result - Objeto do processo (linha do relatório)
	 * @param {Object} col - Definição da coluna (processColumns), deve conter teamByTypeOfProcess
	 * @returns {string} Nome do time ou 'N/I' se não houver time/path/tipo mapeado
	 */
	teamField(result, col) {
		if (!col.teamByTypeOfProcess) {
			return this.fildtype(result, col);
		}
		const typeOfProcess = (result.typeOfProcess || '').toUpperCase();
		const path = col.teamByTypeOfProcess[typeOfProcess];
		if (!path) {
			return 'N/I';
		}
		const teamObj = this.traverse(result, path);
		return (teamObj && teamObj) ? teamObj : 'N/I';
	},
	formatTypeOfBoarding(result) {
		if (!result) {
			return "Não informado";
		}
		return formatTypeOfBoardingValue(result.wayOfTransport, result.typeOfBoarding);
	},
	fildtype(result, col) {
    	const value = this.traverse(result, col.field);
		const typeHandlers = {
			default: () => value,
			identification: () => this.findProcessByIdentificationSearch(value),
			money: () => value ? this.formatCurrency(value) : '',
			boolean: () => this.formatBoolean(value, col.typeValue),
			count: () => this.formatCount(value),
			date: () => this.formatDate(value, "DD/MM/YYYY"),
			datetime: () => this.formatDate(value, "DD/MM/YYYY HH:mm:ss")
		};

		return (typeHandlers[col.type] || (() => value || 'N/I'))();
	},
	// INICIO Métodos auxiliares
	formatCurrency(value) {
		return String(value).toLocaleString("pt-BR", { 
			style: "currency", 
			currency: "BRL" 
		});
	},
	formatBoolean(value, typeValue) {
		return typeValue ? typeValue[value] || value : value ? "Sim" : "Não";
	},
	formatYesOrCheckDate(result, col) {
		const date = col.dateField ? this.traverse(result, col.dateField) : null;
		if (date && moment(date).isValid()) {
			return moment(date).format("DD/MM/YY");
		}
		const checked = this.traverse(result, col.field);
		if (checked === true || checked === "true") {
			return "Sim";
		}
		return "Não";
	},
	formatCount(value) {
		console.log(value);
		return Array.isArray(value) ? value.length : value ? value : 0;
	},
	formatDate(value, format) {
		return value ? this.$moment(value).format(format) : '';
	},
	// FIM Métodos auxiliares
    getXmlDis() {
      this.$store.commit("setLoading", {
        show: true,
        label: "Relatório Geral de Importações",
        description: "Aguarde enquanto o relatório está sendo gerado...",
      });

      try {
        const data = {
          customersIds: this.filter.customers.map((c) => c.id),
          startDate: `${this.$moment(this.filter.date.start).format(
            "Y-MM-DDT"
          )}00:00:00`,
          endDate: `${this.$moment(this.filter.date.end).format(
            "Y-MM-DDT"
          )}23:59:59`,
        };

        const response = Axios.post(
          `${config.env.API_DEFAULT.host}/newImportProcess/generate-zip-xml-di`,
          data
        );

        Swal.fire(
          "Gerar ZIP com XML das DIs",
          "O ZIP está sendo gerado e assim que for finalizado, você receberá um e-mail com o arquivo.",
          "success"
        );

        this.$store.commit("setLoading", {
          show: false,
        });
      } catch (e) {
        console.log(e);
        Swal.fire(
          "Gerar ZIP com XML das DIs",
          "Erro inesperado ao gerar o ZIP de XML's de DI",
          "error"
        );

        this.$store.commit("setLoading", {
          show: false,
        });
      }
    },
    generate(type) {
      this.$store.commit("ProcessStore/SET_FILTERED_PROCESSES", []);
      const {filter} = this;

      if (
        filter.date.field === "" ||
        filter.date.start === "" ||
        filter.date.end === ""
      ) {
        Swal.fire(
          "Relatório Geral de Importações",
          "Você precisa selecionar um período para conseguir gerar o relatório.",
          "error"
        );
      } else {
        this.$store.commit("setLoading", {
          show: true,
          label: "Relatório Geral de Importações",
          description: "Aguarde enquanto o relatório está sendo gerado...",
        });

        let params = "";
        const startDate = `${this.$moment(filter.date.start).format(
          "Y-MM-DDT"
        )}00:00:00`;
        const endDate = `${this.$moment(filter.date.end).format(
          "Y-MM-DDT"
        )}23:59:59`;

        params += `${filter.date.field.attribute}&from=${startDate}&to=${endDate}`;

        if (filter.steps.length > 0) {
          const steps = new Array();
          filter.steps.filter((s) => {
            steps.push(s.id);
          });
          params += `&stepsIds=${steps.join()}`;
        }

        if (filter.customers.length > 0) {
          const customers = new Array();
          filter.customers.filter((o) => {
            customers.push(o.id);
          });
          params += `&customersIds=${customers.join()}`;
        }

        if (filter.customsBrokers.length > 0) {
          const customsBrokers = new Array();
          filter.customsBrokers.filter((o) => {
            customsBrokers.push(o.id);
          });
          params += `&customsBrokersIds=${customsBrokers.join()}`;
        }

        if (filter.exporters.length > 0) {
          const exporters = new Array();
          filter.exporters.filter((o) => {
            exporters.push(o.id);
          });
          params += `&exportersIds=${exporters.join()}`;
        }

        if (filter.teams.length > 0) {
          const teams = new Array();
          filter.teams.filter((o) => {
            teams.push(o.id);
          });
          params += `&teamsIds=${teams.join()}`;
        }

        if (filter.customsTeams.length > 0) {
          const customsTeams = new Array();
          filter.customsTeams.filter((o) => {
            customsTeams.push(o.id);
          });
          params += `&customsTeamIds=${customsTeams.join()}`;
        }

        if (filter.retreatIcms != null) {
          const icmss = new Array();
          filter.retreatIcms.filter((o) => {
            icmss.push(o.value);
          });

          params += `&retreatIcms=${icmss.join()}`;
        }

        if (filter.accounts != null) {
          const accounts = new Array();
          filter.accounts.filter((o) => {
            accounts.push(o.id);
          });
          params += `&accountsIds=${accounts.join()}`;
        }

        if (filter.typeOfProcess != null) {
          const typeOfProcess = new Array();
          filter.typeOfProcess.filter((o) => {
            typeOfProcess.push(o.id);
          });
          params += `&typeOfProcessIds=${typeOfProcess.join()}`;
        }

		if (filter.priority != null) {
			params += `&priority=${filter.priority.id}`;
		} 

		if (filter.drawback != null) {
			params += `&drawback=${filter.drawback.id}`;
		}

		if (filter.priorityTypes.length > 0) {
			const priorityTypes = new Array();
			filter.priorityTypes.filter((o) => {
				priorityTypes.push(o.id);
			});
			params += `&priorityTypesIds=${priorityTypes.join()}`;
		}

        if (filter.diChannels.length > 0) {
          const diChannels = new Array();
          filter.diChannels.filter((o) => {
            diChannels.push(o.id);
          });
          params += `&diChannels=${diChannels.join()}`;
        }

        const columnFields = new Set();

		columnFields.add('id');
		columnFields.add('typeOfProcess');
        this.enabledTableColumns.forEach((column) => {
          columnFields.add(column.field);
          if (column.otherField) {
            Object.entries(column.otherField).forEach(([key, value]) => {
              columnFields.add(key);
              if (value && typeof value === 'object' && !Array.isArray(value)) {
                Object.keys(value).forEach((innerKey) => columnFields.add(innerKey));
              }
            });
          }
          if (column.priorityField) {
            Object.keys(column.priorityField).forEach((key) => columnFields.add(key + '.name'));
          }
		  if (column.teamByTypeOfProcess) {
            Object.values(column.teamByTypeOfProcess).forEach((value) => columnFields.add(value));
          }
        });

        params += `&columns=${Array.from(columnFields).join(',')}`;

        Axios.get(
          `${config.env.API_DEFAULT.host}/process/import/report/general?field=${params}`
        )
          .then((response) => {
            if (response.data.code === "SUCCESS") {
              this.listOfResults = response.data.data;
			  this.listOfResultsExelModity(response.data.data);

            //   this.$store.commit(
            //     "ProcessStore/SET_PROCESSES",
            //     response.data.data
            //   );

              this.processesIdsToList = response.data.data
                .filter((item) => item.id !== "NaN" && item.id !== NaN)
                .map((item) => item.id)
                .join(",");

              if (type === "PDF") {
                this.generatePdfReport();
              } else {
                Swal.fire(
                  "Relatório Geral de Importações",
                  response.data.message,
                  "success"
                );
              }
            } else {
              Swal.fire(
                "Relatório Geral de Importações",
                response.data.message,
                "error"
              );
            }
          })
          .catch((error) => {
            this.$store.commit("setLoading", {
              show: false,
            });
          })
          .finally(() => {
            this.$store.commit("setLoading", {
              show: false,
            });
          });
      }
    },
	listOfResultsExelModity(data) {
		let listOfResults = [];
		let processColumnsListOtherField = processColumns.filter((column) => column.otherField);
		let processColumnsListPriorityField = processColumns.filter((column) => column.priorityField);

		data.forEach(result => {
			const modifiedResult = {...result};
			processColumnsListOtherField.forEach(col => {
				for (const [fieldToCheck, conditions] of Object.entries(col.otherField)) {
					// Verifica se todas as condições são atendidas
					const allConditionsMet = Object.entries(conditions).every(([key, value]) => {
						return result[key] === value;
					});

					// Se todas as condições forem atendidas, retorna o valor do campo
					if (allConditionsMet) {
						modifiedResult[col.field] = modifiedResult[fieldToCheck];
					}
				}
			});
			processColumnsListPriorityField.forEach(col => {
				for (const [entityKey, propertyName] of Object.entries(col.priorityField)) {
					if (result[entityKey]) {
						// Acessa a propriedade dentro da entidade
						const value = result[entityKey][propertyName];

						if (value !== undefined && value !== null) {
							modifiedResult[col.field] = value;
						}
					}
				}
			});
			listOfResults.push(modifiedResult);
		});

		this.listOfResultsExel = listOfResults;
	},
    async generatePdfReport() {
      this.$refs.html2Pdf.generatePdf();

      this.$store.commit("setLoading", {
        show: false,
      });
    },
    printDemonstrative(data) {
      const requestConfiguration = {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.env.API_JSREPORTONLINE.credentials.token,
          responseType: "arraybuffer",
        },
      };

      const {account} = this.$store.state.credentials.data;

      delete account.logo;
      const requestData = {
        template: {
          shortid: "zNNe8GP",
          recipe: "chrome-pdf",
        },
        data: {
          account: {
            ...account,
            logo: "https://s3.sa-east-1.amazonaws.com/public.prime.com.vc/logo/nova/logo-horizontal-azul.png",
          },
          data,
        },
      };

      jsreport.serverUrl = config.env.API_JSREPORTONLINE.host;
      jsreport.headers.Authorization =
        config.env.API_JSREPORTONLINE.credentials.token;

      jsreport
        .renderAsync(requestData)
        .then((res) => {
          // open download dialog
          res.download("Relatório Geral de Importações.pdf");
          res.xhr.getResponseHeader("Content-Type");
          this.$store.commit("setLoading", {
            show: false,
          });
        })
        .catch((error) => {
          this.$store.commit("setLoading", {
            show: false,
          });
          Swal.fire(
            "Relatório Geral de Importações",
            `Houve algum erro ao tentar gerar o demonstrativo desta DI: <strong>${error.response.data.message}</strong>`,
            "error"
          );
        });
    },
    async findProcessByIdentificationSearch(processReference) {
      try {
		if (!processReference) {
			Swal.fire("Processo de Importação", "A referência não pode ser nula ou vazia", "error");
			return;
		}
		const processReferenceNumbersOnly = processReference.toString().replace(/\D/g, '');
		const route = this.$router.resolve(`/operational/imp/desk?showProcess=true&identification=${processReferenceNumbersOnly}`);
		window.open(route.href, '_blank');

      } catch (error) {
        Swal.fire("Processo de Importação", error.response, "error");
      }
    },
  },
  watch: {},
  computed: {
    ...mapState({
      steps: (state) => state.ProcessStore.steps,
    }),
    reportDeskSteps() {
      return (this.filter.steps || []).map((step) => step.id);
    },
    activeDeskState() {
      if (!this.activeDeskStateKey) return null;

      return (
        this.deskStates.find(
          (state) => this.getDeskStateKey(state) === this.activeDeskStateKey
        ) || null
      );
    },
    profileButtonLabel() {
      if (this.activeDeskState && this.activeDeskState.name) {
        return `Perfil: ${this.activeDeskState.name}`;
      }

      return "Perfil";
    },
    profileButtonTitle() {
      if (this.activeDeskState && this.activeDeskState.name) {
        return `Perfil ativo: ${this.activeDeskState.name}`;
      }

      return "Perfil";
    },
    reportDeskFilter() {
      return this.mapReportFilterToDeskFilter(this.filter);
    },
    reportDeskColumns() {
      return this.mapReportColumnsToDeskColumns(this.tableColumns);
    },
    excelColumns() {
      const excelCols = {};

      for (let i = 0; i < this.enabledTableColumns.length; i++) {
        const column = this.enabledTableColumns[i];

		if (column.enabled === true) {
          if (column.type === "date") {
            Object.assign(excelCols, {
              [column.alt || column.label]: {
                field: column.field,
                callback: (value) =>
                  `${value ? moment(value).format("DD/MM/YYYY") : "N/I"}`,
              },
            });
		  } else if (column.type === "datetime") {
				Object.assign(excelCols, {
					[column.alt || column.label]: {
						field: column.field,
						callback: (value) =>
							`${value ? moment(value).format("DD/MM/YYYY HH:mm:ss") : "N/I"}`,
					  },
				});
          } else if (column.dateField) {
            Object.assign(excelCols, {
              [column.alt || column.label]: {
                field: "id",
                callback: (value) => {
                  const row = this.listOfResultsExel.find((r) => r.id === value);
                  return row ? this.formatYesOrCheckDate(row, column) : "Não";
                },
              },
            });
          } else if (column.type === "boolean" && !column?.typeValue) {
            Object.assign(excelCols, {
				[column.alt || column.label]: {
					field: column.field,
					callback: (value) => `${value ? "SIM" : "NÃO"}`,
				},
            });
		  } else if (column.type === "count") {
			Object.assign(excelCols, {
				[column.alt || column.label]: {
					field: column.field,
					callback: (value) => `${value.length || 0}`,
				},
			});
		  } else if (column.type === "default" && column.typeOptions) {
			Object.assign(excelCols, {
				[column.alt || column.label]: {
					field: column.field,
					callback: (value) => column.typeOptions[value] || value,
				},
			});
		 } else if (column.type === "boolean" && column?.typeValue) {
            Object.assign(excelCols, {
				[column.alt || column.label]: {
				field: column.field,
					callback: (value) => column.typeValue[value] || column?.typeValueDefault || value,
				},
            });
          } else if (column.type === "money") {
            Object.assign(excelCols, {
              [column.alt || column.label]: {
                field: column.field,
                callback: (value) =>
                  Number(value || 0).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }),
              },
            });
		  } else if (column.type === "array") {
			Object.assign(excelCols, {
				[column.alt || column.label]: {
					field: column.field,
					callback: (value) => value.map(item => item[column.arrayField]).join(', '),
				},
			});
		  } else if (column.type === "default" && column.teamByTypeOfProcess) {
			Object.assign(excelCols, {
				[column.alt || column.label]: {
					field: 'id',
					callback: (value) => {
						const row = this.listOfResultsExel.find((r) => r.id === value);
						return row ? this.teamField(row, column) : 'N/I';
					},
				},
			});
		  } else if (column.field === "typeOfBoarding") {
			Object.assign(excelCols, {
				[column.alt || column.label]: {
					field: "id",
					callback: (value) => {
						const row = this.listOfResultsExel.find((r) => r.id === value);
						return row ? this.formatTypeOfBoarding(row) : "Não informado";
					},
				},
			});
          } else {
            Object.assign(excelCols, {
              [column.alt || column.label]: column.field,
            });
          }
        }
      }

      return excelCols;
    },
    enabledTableColumns: {
      get() {
        return this.tableColumns.filter((col) => col.enabled === true);
      },
      set(value) {
        return value;
      },
    },
    filteredTableColumns() {
      if (this.disabledColumnsSearch && this.disabledColumnsSearch.trim() !== "") {
        const searchTerm = this.normalizeColumnSearchText(this.disabledColumnsSearch.trim());

        return this.tableColumns.filter((col) => {
          if (!col || !col.label) return false;
          return this.normalizeColumnSearchText(col.label).includes(searchTerm);
        });
      }
      return this.tableColumns;
    },
    listOfDatesFields() {
      const data = new Array();

      if (this.labels !== undefined) {
        for (const prop in this.labels) {
          if (this.labels[prop].type === "date") {
            data.push(this.labels[prop]);
          }
        }
      }

      data.push(
        {
          attribute: "productCatalogDate",
          label: "Catálogo",
          type: "date",
        },
        {
          attribute: "administrativeTreatmentDoneDate",
          label: "TA Feito",
          type: "date",
        }
      );

      return data;
    },
  },
  mounted() {
    this.$store.dispatch("ProcessStore/getSteps");
	this.getPriorityTypes();
    this.loadDeskStates();
    EventBus.$on("operational.imp.Desk.loadDeskStates", () => {
      this.loadDeskStates();
    });

    this.$store.commit("setLoading", {
      show: true,
      label: "Aguarde...",
      description: "Carregando informações para filtro do relatório...",
    });

    Axios.get(
      // `${config.env.API_DEFAULT.host}/companies/search/findAllByIsCustomBroker?isCustomBroker=true`
      `${config.env.API_DEFAULT.host}/companies/search/findAllByIsCustomBrokerIsTrue`
    ).then((response) => {
      this.listOfCustomsBrokers = response.data._embedded.companies;
    });

    Axios.get(
      `${config.env.API_DEFAULT.host}/companies/search/findAllByIsExporter?isExporter=true`
    ).then((response) => {
      this.listOfExporters = response.data._embedded.companies;
    });

    Axios.get(
      `${config.env.API_DEFAULT.host}/companies/search/findAllByIsCustomerOrderByName?isCustomer=true`
    ).then((response) => {
      this.listOfCustomers = response.data._embedded.companies;
    });

    Axios.get(
      `${config.env.API_DEFAULT.host}/companies/search/findAllByIsCustomerOrderByName?isCustomer=true`
    ).then((response) => {
      this.listOfCustomers = response.data._embedded.companies;
    });

    Axios.get(`${config.env.API_DEFAULT.host}/teams`).then((response) => {
      this.listOfTeams = response.data._embedded.teams;
    });

    Axios.get(`${config.env.API_DEFAULT.host}/customs-teams`).then((response) => {
      this.listOfCustomsTeams = response.data.data;
    });

    Axios.get(`${config.env.API_DEFAULT.host}/accounts/search/findAllByNameContainingIgnoreCase?name=`).then((response) => {
      this.listOfAccount = response.data._embedded.accounts.map(account => {
        return {
          id: account.id,
          name: `${account.federalID} ${account.alias}`
        };
      });
    });

    this.listOfTypeOfProcess = constants.LIST_TYPE_OF_PROCESS.map(type => {
      return {
        id: type.key,
        name: type.value
      };
    });

    this.listOfDiChannels = constants.OPERATIONAL_DI_CHANNELS.map((item) => ({
      id: item.key,
      name: item.value,
    }));
    
    this.$store.commit("setLoading", {show: false});
  },
  beforeDestroy() {
    EventBus.$off("operational.imp.Desk.loadDeskStates");
  },
};
</script>

<style scoped>

.vs__selected-options span.selected-tag {
  margin: 5px 0px 0px -3px !important;
  padding: 5px !important;
}

.report-slim-pagetitle {
  margin-top: 15px;
  margin-bottom: 10px;
  color: #343a40;

  border-left: 4px solid #4662d4;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #343a40;
  padding: 5px;
}

.report-box {
  max-width: 1100px;
  padding: 5px;
  margin: 20px;
  font-size: 16px;
  line-height: 24px;
  font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
  color: #343a40;
}

.report-box table {
  width: 100%;
}

.report-hr {
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 5px;
}

.report-header {
  font-size: 12px;
}

.report-header-left {
  text-align: left;
  border-left: 6px solid #4662d4;
  padding-left: 5px;
}

.report-header-middle {
  padding-left: 20px;
  text-align: left !important;
  line-height: 20px;
}

.report-header-right {
  vertical-align: middle;
  line-height: 10px;
}

.report-header-right small {
  font-size: 10px;
}

.report-list {
  width: 100%;
  border-collapse: collapse;
}

.report-list th {
  text-transform: uppercase;
  font-size: 13px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.8);
}

.report-list td {
  font-size: 11px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.8);
}

.report-footer {
  position: fixed;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: center;
  line-height: 8px;
}

.report-footer small {
  font-size: 9px;
}

.report-tx-center {
  text-align: center;
}

.report-tx-bold {
  font-weight: bold;
}

.report-tx-10 {
  font-size: 10px;
}

.columns-list {
  max-height: calc(100vh - 250px);
  overflow: auto;
  border: 1px solid #e2e2e2;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: white;
}

.columns-list li {
  padding: 0.35rem 0.75rem;
  border-radius: 2px;
  font-weight: 500;
}

.columns-list.active li {
  border-color: #106dc4;
  color: #106dc4;
  background-color: rgba(16, 109, 196, 0.1);
}

.columns-list.active li:hover {
  background-color: #106dc4;
  color: white;
}

.columns-list li:hover {
  cursor: pointer;
}

.list-group-item .user-name-address {
  cursor: pointer;
  width: 100%;
}

.list-group-user .list-group-item:not(.profile-item-active) .user-name-address:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.list-group-user .list-group-item.profile-item-active {
  background-color: rgba(16, 109, 196, 0.08);
  border-left: 3px solid #106dc4;
}

.list-group-user .list-group-item.profile-item-active .user-name-address p {
  color: #106dc4;
  font-weight: 600;
}

.list-group-user .list-group-item.profile-item-active .user-name-address span {
  color: #6c757d;
}

.columns-list .list-group-item.active {
  border: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
